module.exports = __webpack_public_path__ + "static/media/place-holder-bg.2b6de976.svg";